// Section 17: priority group 'Other food producers'. Members are listed in sorted id order; the rationing
// phase ranks groups by the policy's order and breaks ties by lowest strength first.
import { definePriorityGroup } from '../../core/registry';
import { peopleSorted } from '../../core/queries';
import type { Config } from '../../config';

export function foodProducers(_config: Config) {
  return definePriorityGroup({
    id: 'food-producers',
    label: 'Other food producers',
    section: 'S17',
    members: (ctx) =>
      peopleSorted(ctx.state)
        .filter((p) => p.job === 'forager' || p.job === 'hunter')
        .map((p) => p.id),
  });
}
